module.exports = __webpack_public_path__ + "img/charts.f10ac6a2.png";